"use strict";

var SendSMSCode = {
  getSchema: function getSchema() {
    return {
      "properties": {
        "phoneNumber": { "type": "string" }
      },
      "required": ["phoneNumber"]
    };
  },

  execute: function execute(fbApp, body, timestamp, callback) {
    // It is not going to be called
  }
};

module.exports = SendSMSCode;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fibo-app/fibo-collab-shared/build/functions/SendSMSCode.js
// module id = 1029
// module chunks = 0